module.exports = __webpack_public_path__ + "img/horizontal_3_6_7016.1a0b5dc3.png";